import DashboardServiceItem from '@/modules/myServices/entities/DashboardServiceItem'
import { formatDate } from '@/utils'
import { DashboardDomainServiceI } from '@/modules/myServices/types/api/DashboardServices'

export default class DashboardDomainItem extends DashboardServiceItem {
  expiresAt: string | null
  autoRenewEnabled: boolean

  constructor(service: DashboardDomainServiceI, currency: string) {
    super(service, currency)

    this.expiresAt = service.expiresAt ?? null
    this.autoRenewEnabled = service.attributes?.autoRenewEnabled ?? true
  }

  get autoRenewLabel(): string {
    return this.autoRenewEnabled ? 'Enabled' : 'Disabled'
  }

  get expiresAtLabel(): string {
    return formatDate(this.expiresAt)
  }
}
